<template>
    <PvToast
        :group
        :position="isMobile ? 'bottom-center' : 'top-right'"
        :pt="{
            root: {
                class: 'md:right-8 xs:py-4 w-full md:w-auto bottom-0 left-0 md:left-auto',
                style: {
                    opacity: '1 !important',
                    height: 'fit-content !important',
                },
            },
            container: 'ds-toast-container bg-transparent border-none justify-center md:justify-end flex',
        }"
    >
        <template #container="{ message, closeCallback }: { message: ToastMessageOptions; closeCallback: () => void }">
            <DsToastMessage
                :message="message"
                @close="closeCallback"
            />
        </template>
    </PvToast>
</template>

<script setup lang="ts">
import { isMobile } from '@/components/Composables/MobileScreenDetection';
import DsToastMessage from '@/components/design-system/toast/DsToastMessage.vue';
import type { ToastMessageOptions } from 'primevue/toast';
import PvToast from 'primevue/toast';

withDefaults(
    defineProps<{
        group?: string;
    }>(),
    {
        group: 'ds-toast',
    },
);
</script>

<style scoped lang="scss">
.ds-toast-container {
    @apply rounded-lg py-2 pl-4 pr-3;
}
</style>
